import type { FlowStep, FlowTrigger } from '../MagicFlowAdmin.types';

export type FlowBuilderValue = {
  steps?: FlowStep[];
  triggers?: FlowTrigger[];
  custom_variables?: Record<string, unknown>;
};

export const DEFAULT_FLOW_BUILDER_VALUE: FlowBuilderValue = {
  steps: [
    {
      id: 'start',
      name: 'Start',
      type: 'start',
      next: 'step_1',
    },
    {
      id: 'step_1',
      name: 'Step 1',
      type: 'action',
      action: {
        type: 'echo',
        inputs: {
          message: 'Hello world',
        },
      },
      next: 'end',
    },
    {
      id: 'end',
      name: 'End',
      type: 'end',
    },
  ],
  triggers: [],
  custom_variables: {},
};
